import { render, staticRenderFns } from "./AffirmResellers.vue?vue&type=template&id=28403890&"
import script from "./AffirmResellers.vue?vue&type=script&lang=js&"
export * from "./AffirmResellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports